import { createTheme } from 'react-data-table-component';

export const tableStyle = {
  table: {
    style: {
      backgroundColor: 'transparent',
      padding: '0',
      boxShadow:
        '0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)',
    },
  },
  tableWrapper: {
    style: {
      display: 'table',
    },
  },

  cell: {
    style: {
      //   "z-index": "99 !important",
    },
  },
  headRow: {
    style: {
      backgroundColor: 'rgba(30, 122, 132,0.1)',
      fontSize: '16px',
      fontWeight: 'bold',
    },
  },

  rows: {
    style: {
      //   "z-index": "0 !important",
      '&:hover': {
        backgroundColor: '#eff2f7',
      },
    },
  },
  pagination: {
    style: {
      border: 'none',
    },
    pageButtonsStyle: {
      borderRadius: '50%',
      height: '40px',
      width: '40px',
      padding: '8px',
      margin: 'px',
      cursor: 'pointer',
      transition: '0.4s',
      // color: theme.button.default,
      // fill: theme.button.default,
      backgroundColor: 'transparent',
      '&:disabled': {
        cursor: 'unset',
        // color: theme.button.disabled,
        // fill: theme.button.disabled,
      },
      '&:hover:not(:disabled)': {
        // backgroundColor: theme.button.hover,
      },
      '&:focus': {
        outline: 'none',
        // backgroundColor: theme.button.focus,
      },
    },
  },
};

createTheme(
  'default',
  {
    text: {
      primary: '#1E293B',
      secondary: '#64758B',
    },

    context: {
      background: '#1E293B',
      text: '#FFFFFF',
    },
    // divider: {
    //   default: '#b2b2b2',
    // },
    action: {
      button: 'rgba(0,0,0,.54)',
      hover: 'rgba(0,0,0,.08)',
      disabled: 'rgba(0,0,0,.12)',
    },
  },
  'dark'
);
